import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: .8rem;
  padding: .6rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 100%;    
  height: 2.8rem !important;
  margin: 0 !important;
`
